import React from "react";
import Placeholder from '../../../../../stories/core-components/Shimmer/ShimmerUI';

const LeadGenFormLoaderUI = () => {
    return (
        <>
            <div>
                <Placeholder display="flex" ldrWidth="150px" ldrHeight="2rem" margin="0 0 8px 0"/>
                <Placeholder
                    display="flex"
                    ldrHeight="3.5rem"
                    margin="0 0 20px 0"
                />
            </div>
            <div>
                <Placeholder display="flex" ldrWidth="150px" ldrHeight="2rem" margin="0 0 8px 0"/>
                <Placeholder
                    display="flex"
                    ldrHeight="3.5rem"
                    margin="0 0 20px 0"
                />
            </div>
            <div>
                <Placeholder display="flex" ldrWidth="150px" ldrHeight="2rem" margin="0 0 8px 0"/>
                <Placeholder
                    display="flex"
                    ldrHeight="3.5rem"
                    margin="0 0 20px 0"
                />
            </div>
        </>
    );
  
};

export default LeadGenFormLoaderUI;
